import Hobbies from "./Hobbies";

export default Hobbies;
